import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TimelineItemCard from "../utils/timeline-card.vue";
import ChangelogMixin from "@Broker/@Modules/clients/board/client-profile/mixins/changelog-mixin.js";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChangelogLinkApplication",
  components: {
    TimelineItemCard
  },
  mixins: [ChangelogMixin],
  props: {
    value: {
      type: null,
      required: true
    },
    operation: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    userDetails: {
      type: Object,
      required: true
    },
    insertionTimestamp: {
      type: String,
      required: true
    },
    smallText: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    applications() {
      return this.value.applications;
    },
    linkAppMessage() {
      return this.applications.length <= 1 ? "client-profile.changelog.linkApplicationSingularMessage" : "client-profile.changelog.linkApplicationPluralMessage";
    }
  },
  methods: {
    last(index) {
      return index !== _Object$keys(this.applications).length - 1;
    },
    formatMoneyValue(value) {
      return this.$options.filters.formatMoneyValue(value);
    },
    coappsString(coApplicants) {
      return _reduceInstanceProperty(coApplicants).call(coApplicants, (acc, coapp, idx) => {
        const separator = idx + 1 === coApplicants.length ? "" : ", ";
        acc += `${this.$options.filters.fullName(coapp)}${separator}`;
        return acc;
      }, "");
    }
  }
});